/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Status_Export_CompleteInputs */



/**
* | output |
* | --- |
* | "Export complete!" |
*
* @param {Image_Export_Status_Export_CompleteInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_status_export_complete = /** @type {((inputs?: Image_Export_Status_Export_CompleteInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Status_Export_CompleteInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Exportation terminee !")
	if (locale === "de") return /** @type {LocalizedString} */ ("Export abgeschlossen!")
	if (locale === "it") return /** @type {LocalizedString} */ ("Esportazione completata!")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Экспорт завершен!")
	if (locale === "es") return /** @type {LocalizedString} */ ("¡Exportación completada!")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("导出完成！")
	if (locale === "ja") return /** @type {LocalizedString} */ ("エクスポートが完了しました!")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निर्यात पूरा हुआ!")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Exportação concluída!")
	return /** @type {LocalizedString} */ ("Export complete!")
});